import { render, staticRenderFns } from "./PiutangOverdue.vue?vue&type=template&id=5280dd29&scoped=true&"
import script from "./PiutangOverdue.vue?vue&type=script&lang=js&"
export * from "./PiutangOverdue.vue?vue&type=script&lang=js&"
import style0 from "./PiutangOverdue.vue?vue&type=style&index=0&id=5280dd29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280dd29",
  null
  
)

export default component.exports